import { isMobilePurpleUseragent, makeElement } from "../../../common/Utils";
import { AbsSocial } from "./AbsSocial";
import { ga360 } from "./GA360";

export class Twitter extends AbsSocial {

    name: SocialName = 'twitter'
    dataContents = ga360.dataContents.twitter;
    dataArea = ga360.dataArea.common;

    constructor(protected ElShareItemWrap: HTMLElement, protected option: ShareOption){
        super(ElShareItemWrap, option);

        this.init();
    }

    async callShare(): Promise<void> {
      const targetUrl = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.option.shareUrl);

      if(isMobilePurpleUseragent()){
          location.href = `ncmtalk://external?url=${targetUrl}`;
      }else{
          window.open(targetUrl, '_blank');
      }
    }


}
